import {
  Box,
  Button,
  Stack,
  Divider,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

import { useSelfSubscriptionCourses } from "../../api/getSelfSubscriptionCourses";
import GridList from "../../../../ui/components/List/GridList";
import GridListItem from "../../../../ui/components/List/GridListItem";
import { baseUrl } from "../../../../shared/config";
import { useSearchParams } from "react-router-dom";
import React from "react";
import PickTurma from "./PickTurma";

import CancelEnrollment from "./CancelEnrollment";

const SelfSubscriptionCourses = () => {
  const [searchParams] = useSearchParams();
  const ids = searchParams.get("ids");
  const { data, isLoading } = useSelfSubscriptionCourses({
    config: {
      select: (_data) => {
        const idsArray = ids?.split(",");
        if (idsArray?.length) {
          return _data
            .filter((item) => {
              return idsArray.includes(String(item.cursoid));
            })
            .sort((itemA, itemB) => {
              return (
                idsArray.indexOf(String(itemA.cursoid)) -
                idsArray.indexOf(String(itemB.cursoid))
              );
            });
        } else {
          return _data;
        }
      },
    },
  });
  return (
    <GridList loading={isLoading}>
      {data?.map((course) => {
        const isEnrolled = course.JaMatriculado === "Sim";

        return (
          <GridListItem
            label={course.curso}
            imageUrl={`${baseUrl}/Membros/fotos/${course.foto}`}
            // ActionAreaProps={{ disabled: true }}
            footer={
              <Stack
                sx={{
                  padding: 2,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Divider />
                <Typography color="textSecondary">
                  Duração: {course.duracao_dias}
                </Typography>
                <Typography color="textSecondary">
                  Carga horária: {course.carga_horaria}
                </Typography>
                <span className="relative w-full flex justify-center p-2">
                  <Tooltip
                    sx={{ position: "absolute", right: "0" }}
                    title={
                      <React.Fragment>
                        <Box
                          sx={{ fontSize: "0.8rem" }}
                          dangerouslySetInnerHTML={{
                            __html: course.conteudo,
                          }}
                        />
                      </React.Fragment>
                    }
                  >
                    <IconButton color="info">
                      <InfoOutlined />
                    </IconButton>
                  </Tooltip>
                  <span className="w-full flex flex-col gap-1 align-center justify-center">
                    <PickTurma courseId={course.disciplinaid} course={course}>
                      {({ openDialog }) => {
                        return (
                          <Button
                            className="w-fit ml-auto"
                            variant="outlined"
                            color={isEnrolled ? "success" : "primary"}
                            onClick={openDialog}
                          >
                            {isEnrolled
                              ? "Ver minha matrícula"
                              : "Matricular-me"}
                          </Button>
                        );
                      }}
                    </PickTurma>
                    {isEnrolled && (
                      <CancelEnrollment course={course}>
                        {({ openDialog }) => {
                          return (
                            <Button
                              className="w-fit ml-auto"
                              variant="outlined"
                              color={"error"}
                              onClick={openDialog}
                            >
                              Cancelar Matrícula
                            </Button>
                          );
                        }}
                      </CancelEnrollment>
                    )}
                  </span>
                </span>
              </Stack>
            }
          />
        );
      })}
    </GridList>
  );
};

export default SelfSubscriptionCourses;
